<template>
    <div class="fluid">
        <h1 class="app-title">Pesquisas</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fas fa-id-card"
                                class="mx-auto"
                                title="Parâmetros Para Pesquisa">
                            <ParametrosPesquisa
                                    :filtros="filtros"
                                    @consultar="consultar"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-clipboard-check"
                                class="mx-auto"
                                title="Resultado da Pesquisa" >
                            <TabelaPesquisas
                                    ref="tabelaPesquisas"
                                    :resultado="items"
                                    :configTable="configTable"
                                    :filtroComponente="filtro"
                                    :filtros="filtros"
                                    :loading="this.$refs.loading"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @consultarComScroll="(update) => { updated = update; consultarComScroll(); }"
                                    @limparFiltros="limparFiltros"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex > 0 && !props.isLastStep"
                                            @click="props.prevTab()"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right">
                                    <b-button v-if="props.activeTabIndex == 0"
                                              id="btnProxima"
                                              @click="pesquisar"
                                              variant="primary">
                                        Próxima
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12">
                                    <b-button v-if="props.activeTabIndex == 1"
                                              @click="voltar" style="float: left"
                                              variant="secondary">
                                        <i class="fa fa-arrow-left"></i>
                                        Anterior
                                    </b-button>
                                    <b-button v-if="props.activeTabIndex == 1"
                                              @click="exportCSV" style="float: right"
                                              variant="warning">
                                        <i class="fas fa-file-csv"></i>
                                        Exportar CSV
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import ParametrosPesquisa from "./components/ParametrosPesquisa";
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import CompLoading from "../shared/components/CompLoading";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        mixins: [ formatarMixins ],
        components: {
            ParametrosPesquisa,
            TabelaPesquisas,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
            CompFiltroGrid
        },
        data() {
            return {
                updated: false,
                urlApi: null,
                token: null,
                currentScroll: null,
                codigoReceita: null,
                boleto: null,
                acessoCes: false,
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'pesquisa.numerorequisicao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoTexto: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    numeroRequisicao: null,
                    cnj: null,
                    cpfCnpj: null,
                    nomeDevedor: null,
                    dataInicio: null,
                    dataFinal: null,
                    cda: null,
                    numeroRequisicaoSub: null,
                    tipoRequisicacao: null,
                    cnjSub: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuario: null,
                    usuario: null,
                    situacao: null,
                    cdaSub: null
                },
                load: false
            }
        },
        methods: {
            async pesquisar() {
                this.filtros = {
                    numeroRequisicao: this.filtros.numeroRequisicao,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    cda: this.filtros.cda,
                    numeroRequisicaoSub: null,
                    tipoRequisicacao: null,
                    cnjSub: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuario: null,
                    usuario: null,
                    situacao: null,
                    cdaSub: null
                };
                let dataAtual = new Date()

                if(!this.verificarValorVazio(this.filtros.cda)) {
                    this.$refs.tabelaPesquisas.ativarColunaCda();
                }

                if(this.filtros.dataInicio != null && this.filtros.dataInicio != "") {
                    let dataInicial = parseInt(this.filtros.dataInicio.split("-")[0] + "" + this.filtros.dataInicio.split("-")[1] + "" + this.filtros.dataInicio.split("-")[2]);

                    dataAtual = new Date();
                    let dataAtualTratada = parseInt(dataAtual.getFullYear()
                        + "" + (dataAtual.getMonth() < 9 ? "0" : "") + (dataAtual.getMonth() + 1)
                        + "" + (dataAtual.getDate() < 10 ? "0" : "") + (dataAtual.getDate() + 1));

                    if(dataInicial > dataAtualTratada) {
                        this.exibirMensagem("A Data de Início não pode ser maior que a data atual.");
                        return;
                    }
                }
                if(this.filtros.dataFinal != null && this.filtros.dataFinal != "") {
                    let dataInicial = parseInt(this.filtros.dataFinal.split("-")[0] + "" + this.filtros.dataFinal.split("-")[1] + "" + this.filtros.dataFinal.split("-")[2]);

                    dataAtual = new Date();
                    let dataAtualTratada = parseInt(dataAtual.getFullYear() + "" + (dataAtual.getMonth() < 9 ? "0" : "") + (dataAtual.getMonth() + 1)
                        + "" + (dataAtual.getDate() < 10 ? "0" : "") + (dataAtual.getDate() + 1));

                    if(dataInicial > dataAtualTratada) {
                        this.exibirMensagem("A Data Final não pode ser maior que a data atual.");
                        return;
                    }
                }

                if(this.filtros.dataInicio != null && this.filtros.dataInicio != "" && this.filtros.dataFinal != null && this.filtros.dataFinal != "") {
                    let dataInicial = parseInt(this.filtros.dataInicio.split("-")[0] + "" + this.filtros.dataInicio.split("-")[1] + "" + this.filtros.dataInicio.split("-")[2]);
                    let dataFinal = parseInt(this.filtros.dataFinal.split("-")[0] + "" + this.filtros.dataFinal.split("-")[1] + "" + this.filtros.dataFinal.split("-")[2]);

                    if(dataInicial > dataFinal) {
                        this.exibirMensagem("A Data de Início não pode ser maior que a Data Final.");
                        return;
                    }
                }

                this.$refs.wizard.nextTab();

                this.consultar();
            },
            async voltar() {
                this.$refs.wizard.reset();
            },
            async exportCSV() {
                this.$store.commit("setMessages", {});

                const funcionalidade = 'pesquisas';

                let filtrosPesquisa = {
                    numeroRequisicao: this.filtros.numeroRequisicao,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor != null ? this.filtros.nomeDevedor.nome : '',
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    numeroRequisicaoSub: this.filtros.numeroRequisicaoSub,
                    tipoRequisicacao: this.filtros.tipoRequisicacao,
                    cnjSub: this.filtros.cnjSub,
                    filtrarContribuinte: this.filtros.filtrarContribuinte,
                    contribuinte: this.filtros.contribuinte,
                    filtrarDataEmissao: this.filtros.filtrarDataEmissao,
                    dataEmissao: this.filtros.dataEmissao,
                    tipoPagamento: this.filtros.tipoPagamento,
                    formaPagamento: this.filtros.formaPagamento,
                    filtrarValor: this.filtros.filtrarValor,
                    valor: this.filtros.valor,
                    filtrarUsuario: this.filtros.filtrarUsuario,
                    usuario: this.filtros.usuario,
                    situacao: this.filtros.situacao,
                    cda: this.filtros.cda,
                    cdaSub: this.filtros.cdaSub
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/pesquisas/exportarCsv/${funcionalidade}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Pesquisas.csv');
                    document.body.appendChild(link);
                    link.click();
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
                
            },
            verificarObrigatoriedade() {
              return !(this.verificarValorVazio(this.receitaDiversa.receita) ||
                      this.verificarValorVazio(this.receitaDiversa.cpfCnpjDevedor) ||
                      this.verificarValorVazio(this.receitaDiversa.nomeDevedor) ||
                      this.verificarValorVazio(this.receitaDiversa.valor) ||
                      this.verificarValorVazio(this.receitaDiversa.formaPagamento));
            },
            verificarValorVazio(valor) {
              return valor == null || valor === "";
            },

            async consultarComScroll() {
                this.currentScroll = document.documentElement.scrollTop;
                if (this.updated) {
                    this.consultar();
                }
            },

            async consultar() {
                this.$store.commit("setMessages", {});

                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                let formaPagamento = this.filtros.formaPagamento;
                if(this.acessoCes) {
                    if(formaPagamento != null && (formaPagamento.includes(1) || formaPagamento.includes(2))) {
                        let index = formaPagamento.indexOf(1);
                        if (index >= 0) {
                            formaPagamento.splice(index, 1);
                        }
                        index = formaPagamento.indexOf(2);
                        if (index >= 0) {
                            formaPagamento.splice(index, 1);
                        }
                    }

                    if (formaPagamento == null || formaPagamento.length == 0) {
                       formaPagamento = [1, 3, 4];
                    }
                }

                let filtrosPesquisa = {
                    numeroRequisicao: this.filtros.numeroRequisicao,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor != null ? this.filtros.nomeDevedor.nome : '',
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    numeroRequisicaoSub: this.filtros.numeroRequisicaoSub,
                    tipoRequisicacao: this.filtros.tipoRequisicacao,
                    cnjSub: this.filtros.cnjSub,
                    filtrarContribuinte: this.filtros.filtrarContribuinte,
                    contribuinte: this.filtros.contribuinte,
                    filtrarDataEmissao: this.filtros.filtrarDataEmissao,
                    dataEmissao: this.filtros.dataEmissao,
                    tipoPagamento: this.filtros.tipoPagamento,
                    formaPagamento: formaPagamento,
                    filtrarValor: this.filtros.filtrarValor,
                    valor: this.filtros.valor,
                    filtrarUsuario: this.filtros.filtrarUsuario,
                    usuario: this.filtros.usuario,
                    situacao: this.filtros.situacao,
                    cda: this.filtros.cda,
                    cdaSub: this.filtros.cdaSub
                };

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/pesquisas/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtrosPesquisa, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;

                    if(!this.verificarValorVazio(this.filtros.cnj)) {
                        for(let i = 0; i < this.items.length; i++) {
                            this.items[i].abrirTodos = true;
                        }
                    }

                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }

                    if(this.currentScroll != null) {
                        setTimeout(()=>{
                            document.documentElement.scrollTop = this.currentScroll;
                            this.currentScroll = null;
                        }, 100);
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },
            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;

                    if(this.filtro.campoFiltro == 'Nº Requisição') {
                        this.filtro.campoMascara = this.filtros.numeroRequisicaoSub;
                    } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                        this.filtro.campoCheckbox = this.filtros.tipoRequisicacao;
                    } else if(this.filtro.campoFiltro == 'Processo(s)') {
                        this.filtro.campoMascara = this.filtros.cnjSub;
                    } else if(this.filtro.campoFiltro == 'Devedor') {
                        this.filtro.filtrarEm = this.filtros.filtrarContribuinte;
                        this.filtro.campoTexto = this.filtros.contribuinte;
                    } else if(this.filtro.campoFiltro == 'Data Emissão') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataEmissao;
                        this.filtro.campoData = this.filtros.dataEmissao;
                    } else if(this.filtro.campoFiltro == 'Forma Pgto') {
                        this.filtro.campoCheckbox = this.filtros.formaPagamento;
                    } else if(this.filtro.campoFiltro == 'Tipo Pgto') {
                        this.filtro.campoCheckbox = this.filtros.tipoPagamento;
                    } else if(this.filtro.campoFiltro == 'Valor (R$)') {
                        this.filtro.filtrarEm = this.filtros.filtrarValor;
                        this.filtro.campoTexto = this.filtros.valor;
                    } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                        this.filtro.filtrarEm = this.filtros.filtrarUsuario;
                        this.filtro.campoTexto = this.filtros.usuario;
                    } else if(this.filtro.campoFiltro == 'Situação Requisição') {
                        this.filtro.campoCheckbox = this.filtros.situacao;
                    } else if(this.filtro.campoFiltro == 'CDA(s)') {
                        this.filtro.campoMascara = this.filtros.cdaSub;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Nº Requisição') {
                    this.filtros.numeroRequisicaoSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                    this.filtros.tipoRequisicacao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Processo(s)') {
                    this.filtros.cnjSub = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.filtros.filtrarContribuinte = this.filtro.filtrarEm;
                    this.filtros.contribuinte = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data Emissão') {
                    this.filtros.filtrarDataEmissao = this.filtro.filtrarEm;
                    this.filtros.dataEmissao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Forma Pgto') {
                    this.filtros.formaPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Tipo Pgto') {
                    this.filtros.tipoPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Valor (R$)') {
                    this.filtros.filtrarValor = this.filtro.filtrarEm;
                    this.filtros.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                    this.filtros.filtrarUsuario = this.filtro.filtrarEm;
                    this.filtros.usuario = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação Requisição') {
                    this.filtros.situacao = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'CDA(s)') {
                    this.filtros.cdaSub = this.filtro.campoMascara;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Nº Requisição') {
                    this.configTable.sortField = 'pesquisa.numerorequisicao';
                } else if(this.filtro.campoFiltro == 'Tipo Requisição') {
                    this.configTable.sortField = 'pesquisa.receita';
                } else if(this.filtro.campoFiltro == 'Processo(s)') {
                    this.configTable.sortField = 'pesquisa.processo';
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.configTable.sortField = 'pesquisa.nomecontribuinte';
                } else if(this.filtro.campoFiltro == 'Data Emissão') {
                    this.configTable.sortField = 'pesquisa.dataemissao';
                } else if(this.filtro.campoFiltro == 'Forma Pgto') {
                    this.configTable.sortField = 'pesquisa.formapagamento';
                } else if(this.filtro.campoFiltro == 'Tipo Pgto') {
                    this.configTable.sortField = 'pesquisa.tipopagamento';
                } else if(this.filtro.campoFiltro == 'Valor (R$)') {
                    this.configTable.sortField = 'pesquisa.valor';
                } else if(this.filtro.campoFiltro == 'Usuário Responsável') {
                    this.configTable.sortField = 'pesquisa.nomeresponsavel';
                } else if(this.filtro.campoFiltro == 'Situação Requisição') {
                    this.configTable.sortField = 'pesquisa.situacao';
                } else if(this.filtro.campoFiltro == 'CDA(s)') {
                    this.configTable.sortField = 'pesquisa.cdas';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    numeroRequisicao: this.filtros.numeroRequisicao,
                    cnj: this.filtros.cnj,
                    cpfCnpj: this.filtros.cpfCnpj,
                    nomeDevedor: this.filtros.nomeDevedor,
                    dataInicio: this.filtros.dataInicio,
                    dataFinal: this.filtros.dataFinal,
                    cda: this.filtros.cda,
                    numeroRequisicaoSub: null,
                    tipoRequisicacao: null,
                    cnjSub: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarUsuario: null,
                    usuario: null,
                    situacao: null,
                    cdaSub: null
                };

                this.consultar();
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.acessoCes = true;
            let userData = JSON.parse(this.$store.getters.getUser);
            const gruposSfepge = ['SFEPGE-ADMINISTRADOR', 'SFEPGE-ADMINISTRATIVO', 'SFEPGE-GOFS', 'SFEPGE-TESOUREIRO', 'SFEPGE-PROCURADOR'];
            if (userData.groups) {
                for (let i = 0; i < userData.groups.length; i++) {
                    if(userData.groups[i] == 'SFEPGE-CES') {
                        this.acessoCes = true;
                    } else if(gruposSfepge.includes(userData.groups[i])) {
                        this.acessoCes = false;
                        break;
                    }
                }
            }
        },
    }
</script>
